export const RgbStyle = {
    background: "linear-gradient(to right, #000000, #1A1A1E)",
    color: "linear-gradient(45deg, rgb(38, 227, 196), rgb(14, 1, 44), #5a6c80, rgb(38, 227, 196)) 1",
    padding: "20px",
    borderRadius: "10px",
    border: "3px solid",
    borderImageSlice: 1,
};
